// extracted by mini-css-extract-plugin
export var dropdownIcon = "_rq-6";
export var imgContainer = "_rq-3";
export var menuIcon = "_rq-5";
export var pillWrapper = "_rq-2";
export var pillsContainer = "_rq-1";
export var subscriptionCard = "_rq-0";
export var subscriptionLogo = "_rq-4";